import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Overlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 900;
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 16px 25px;
  padding-bottom: 24px;
  width: 408px;
  height: fit-content;
  display: flex;
  align-self: center;
  justify-self: center;
  flex-direction: column;
  z-index: 100;
  position: fixed;

  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 16px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }

  span {
    display: inline-flex;
  }
`;

export const Title = styled.section`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    display: inline-flex;
  }
`;

export const TitleText = styled.div`
  font-weight: 600;
  font-size: 1rem;
  line-height: 24px;
  color: #1b203a;
  margin: unset;
`;

export const Span = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`;

export const ProductInfoContainer = styled.section`
  padding: 10px 12px;
  background: #f9fafc;
  border: 1px solid #e6e8f0;
  border-radius: 6px;
  display: flex;
  gap: 12px;
  margin: 12px 0px;
`;

export const ImagePlaceHolder = styled.div`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
`;

export const ProductImage = styled(BrokenImage)`
  object-fit: cover;
  width: 36px;
  min-width: 36px;
  height: 36px;
`;

export const ProductInfoSection = styled.div``;

export const ProductNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    display: inline-flex;
    cursor: pointer;
  }
`;

export const ProductName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
`;

interface IProductParagraph {
  color?: string;
  size?: string;
  margin?: string;
  lineHeight?: number;
  weight?: number;
}

export const ProductParagraph = styled.p<IProductParagraph>`
  font-size: ${props => (props.size ? props.size : '14px')};
  line-height: ${props =>
    props.lineHeight ? `${props.lineHeight}px` : '22px'};
  color: ${props => (props.color ? props.color : '#474D66')};
  margin: ${props => (props.margin ? props.margin : 'unset')};
  font-weight: ${props => (props.weight ? props.weight : 400)};
`;

export const ProductNameEmpty = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;

export const ModelEmpty = styled.div`
  color: #c1c4d6;
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
`;

export const ProductActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const ActionButton = styled.button`
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  outline: none;

  &[data-blue='true'] {
    background: #1371fe;
    color: #ffffff;

    :disabled {
      background-color: #edeff4;
      color: #c1c4d6;
    }
  }

  &[data-neutral='true'] {
    background: transparent;
    color: #474d66;
  }
`;

export const ProductToolTip = styled.div`
  height: 24px;

  span {
    display: inline-flex;
  }
`;
